import { render, staticRenderFns } from "./MyLeaveListTable.vue?vue&type=template&id=710a03d3"
import script from "./MyLeaveListTable.vue?vue&type=script&lang=js"
export * from "./MyLeaveListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports